export default __webpack_public_path__ + "static/media/world2doortext3.ed07121c.png";